import { Stack, Typography } from "@mui/material";
import {
  H1,
  H3,
  P_REGULAR,
  SECONDARY_MAIN,
} from "../../../Constants/CommonConstants";
import { useIntl } from "react-intl";
import {
  LOGIN_VERIFICATION_METHOD_HEADING,
  LOGIN_VERIFICATION_METHOD_TEXT,
  OPTIONAL_LABEL,
} from "../../../Constants/LoginVerificationMethodsConstants";
import {
  StyledVerificationMethodOptionalText,
  StyledVerificationMethodOptionalTextAlign,
} from "../../../Styles/Login/LoginVerificationMethods/LoginVerificationMethodsStyles";

/**
 * @description LoginVerificationMethodsHeading component providers headers and static text to be used in login verification methods screen.
 * @returns {ReactNode} Renders the headers and static text.
 */

export const LoginVerificationMethodsHeading = () => {
  const intl = useIntl();

  return (
    <Stack spacing={2}>
      <StyledVerificationMethodOptionalTextAlign>
        <Typography
          component={H1}
          variant={H3}
          color={SECONDARY_MAIN}
          id={LOGIN_VERIFICATION_METHOD_HEADING}
        >
          {intl.formatMessage({ id: LOGIN_VERIFICATION_METHOD_HEADING })}
        </Typography>
        <StyledVerificationMethodOptionalText
          variant={P_REGULAR}
          id={OPTIONAL_LABEL}
          isOptional
        >
          {intl.formatMessage({ id: OPTIONAL_LABEL })}
        </StyledVerificationMethodOptionalText>
      </StyledVerificationMethodOptionalTextAlign>
      <Typography variant={P_REGULAR} id={LOGIN_VERIFICATION_METHOD_TEXT}>
        {intl.formatMessage({ id: LOGIN_VERIFICATION_METHOD_TEXT })}
      </Typography>
    </Stack>
  );
};

export default LoginVerificationMethodsHeading;
